// @ts-nocheck -- third-party RTB House tracking snippet, kept verbatim
import { defaultConsents, getUserConsent } from "@fruugo/utilities";

const userId = "unknown";

export function shouldEnableRTBHouse(): boolean {
  const consents = getUserConsent() || defaultConsents;
  return consents.advertising;
}

function determineDataCenterValue() {
  switch (window.currentCountry) {
    case "NZ":
    case "AU":
      return "asia";
    case "US":
    case "CA":
      return "us";
    default:
      return "";
  }
}

export function initRTBHouseTracking() {
  if (!shouldEnableRTBHouse()) return;
  (function (w, d, dn, t) {
    w[dn] = w[dn] || [];
    w[dn].push({ eventType: "init", value: t, dc: determineDataCenterValue() });
    var f = d.getElementsByTagName("script")[0],
      c = d.createElement("script");
    c.async = true;
    c.src = "https://tags.creativecdn.com/lS4uLZeAFEWiNnbn9H7W.js";
    f.parentNode.insertBefore(c, f);
  })(window, document, "rtbhEvents", "lS4uLZeAFEWiNnbn9H7W");
}

export function sendRTBHomePageViewEvent() {
  if (!shouldEnableRTBHouse()) return;
  (rtbhEvents = window.rtbhEvents || []).push(
    {
      eventType: "home",
    },
    {
      eventType: "uid",
      id: userId,
    }
  );
}

export function sendRTBProductPageViewEvent(productId: string) {
  if (!shouldEnableRTBHouse()) return;
  if (!productId) return;
  (rtbhEvents = window.rtbhEvents || []).push(
    {
      eventType: "offer",
      offerId: productId,
    },
    {
      eventType: "uid",
      id: userId,
    }
  );
}

export function sendRTBAddToCartEvent(productId: string) {
  if (!shouldEnableRTBHouse()) return;
  if (!productId) return;
  (rtbhEvents = window.rtbhEvents || []).push(
    {
      eventType: "basketadd",
      offerId: productId,
    },
    {
      eventType: "uid",
      id: userId,
    }
  );
}
